import React, { useEffect, useRef } from "react";
import popUpBG from "./images/popUpBG.png";
import crossIcon from "./images/crossIcon.png";

const HeadsPopUp = ({ status, image }) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        status(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [status]);

  const popupRef = useRef();

  return (
    <div style={style.parent}>
      <div style={style.popUpContainer} ref={popupRef}>
        <div style={style.popUpBackground} className="NewsPopUp">
          <div style={style.crossicon} onClick={() => status(false)}>
            <img src={crossIcon} alt="cross-icon" />
          </div>
          <div>
            <img src={image} className="newsImg" alt="news" />
          </div>
        </div>
      </div>
    </div>
  );
};

const style = {
  parent: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: "10",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.5)",
  },


  popUpContainer: {
    width: "80%",
    maxWidth: "950px", // Adjust the max-width as needed
    borderRadius: "20px",
    overflow: "hidden",
  },
  popUpBackground: {
    backgroundImage: `url(${popUpBG})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "20px",
    overflowY: "auto",
  },
  crossicon: {
    position: "absolute",
    top: "10px",
    right: "10px",
    cursor: "pointer",
  },
  popUpHeader: {
    display: "flex",
    justifyContent: "center",
    fontSize: "24px",
    fontWeight: "900",
    color: " #5E1010",
  },
  tableContainer: {
    margin: "20px 50px",
    borderRadius: "20px",
    overflow: "scroll",
    height: "28vw",
  },
  table: {
    width: "100%",
    textAlign: "center",
  },
  tableFirstColumn: {
    backgroundColor: "#EDC2C2",
    height: "50px",
  },
  tableSecondColumn: {
    backgroundColor: "#FFC4C4",
    height: "50px",
  },
  tableThirdColumn: {
    backgroundColor: "#E99292",
    height: "50px",
  },
};

export default HeadsPopUp;
